var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { id: "privacyPolicy" } }, [
    _c("div", {
      staticClass: "title",
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("global." + _vm.translationSection + ".title") +
            " " +
            _vm.$t("privacy_policy.privacy_policy")
        ),
      },
    }),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("privacy_policy.p_start", {
            app: _vm.$t("global." + _vm.translationSection + ".app_name"),
          })
        ),
      },
    }),
    _c("h3", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.h_intro")) },
    }),
    _c("p", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.p_intro")) },
    }),
    _vm._m(0),
    _c("h3", {
      domProps: {
        innerHTML: _vm._s(_vm.$t("privacy_policy.h_info_collection")),
      },
    }),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(_vm.$t("privacy_policy.p_info_collection")),
      },
    }),
    _c("h3", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.h_info_use")) },
    }),
    _c("p", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.p_info_use")) },
    }),
    _c("ul", [
      _c("li", {
        domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.use_1")) },
      }),
      _c("li", {
        domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.use_2")) },
      }),
      _c("li", {
        domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.use_3")) },
      }),
      _c("li", {
        domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.use_4")) },
      }),
    ]),
    _c("h3", {
      domProps: {
        innerHTML: _vm._s(_vm.$t("privacy_policy.h_info_disclosure")),
      },
    }),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(_vm.$t("privacy_policy.p_info_disclosure")),
      },
    }),
    _c("ul", [
      _c("li", {
        domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.disclosure_1")) },
      }),
      _c("li", {
        domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.disclosure_2")) },
      }),
      _c("li", {
        domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.disclosure_3")) },
      }),
    ]),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(_vm.$t("privacy_policy.p_info_disclosure_also")),
      },
    }),
    _c("ul", [
      _c("li", {
        domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.disclosure_4")) },
      }),
      _c("li", {
        domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.disclosure_5")) },
      }),
      _c("li", {
        domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.disclosure_6")) },
      }),
    ]),
    _c("h3", {
      domProps: {
        innerHTML: _vm._s(_vm.$t("privacy_policy.h_info_protection")),
      },
    }),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(_vm.$t("privacy_policy.p_info_protection")),
      },
    }),
    _c("h3", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.h_age_policy")) },
    }),
    _c("p", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.p_age_policy")) },
    }),
    _c("h3", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.h_change_policy")) },
    }),
    _c("p", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.p_change_policy")) },
    }),
    _c("h3", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.h_delete_info")) },
    }),
    _c("p", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.p_delete_info")) },
    }),
    _c("h3", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.h_contact_info")) },
    }),
    _c("p", {
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.p_contact_info")) },
    }),
    _c("br"),
    _c("span", {
      attrs: { id: "footnote" },
      domProps: { innerHTML: _vm._s(_vm.$t("privacy_policy.p_last_revised")) },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("a", { attrs: { href: "https://www.facebook.com" } }, [
        _vm._v("Facebook"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }